import styled from 'styled-components';

export const StyledDescriptionTooltip = styled.div`
  position: relative;
  display: inline-block;
  margin-block: 0.1rem;
  &:hover .tooltip-content {
    opacity: 1;
    visibility: visible;
  }

  .tooltip-activator {
    cursor: help;
  }

  .tooltip-content {
    position: absolute;
    width: fit-content;
    width: 16.5rem;
    bottom: calc(100% + 0.1rem);
    left: 50%;
    transform: none;
    visibility: hidden;
    transition: opacity 0.2s, visibility 0.2s;
    padding: 0.65rem 1rem;
    text-align: left;
    border-radius: 0.25rem;
    background-color: #f6f6f7;
    border: 1px solid #ddd;
    box-shadow: 0 0.1rem 0.15rem rgba(0, 0, 0, 0.1);
    z-index: 20;

    // prevent scroll over screen
    left: auto;
    right: auto;
  }

  .tooltip-content::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 0.35rem;
    border-style: solid;
    border-color: #ccc transparent transparent transparent;
  }
`;
